// Catering Order Tax Related Enums

// Tax Type Enum
export enum TaxType {
  PERCENTAGE = 'percentage',
  FIXED = 'fixed',
}

export interface ICateringOrderTax {
  id: number;
  cateringOrderId: string;
  taxName: string;
  type: TaxType;
  value: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface ICateringOrderServiceCharge {
  id: number;
  cateringOrderId: string;
  serviceChargeName: string;
  type: TaxType;
  value: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface TaxItem {
  id: number | null;
  taxName: string;
  type: TaxType;
  value: number | string;
}
export interface ServiceChargeItem {
  id: number | null;
  serviceChargeName: string;
  type: TaxType;
  value: number | string;
}
